import React, { createContext, useContext, useState, useCallback } from 'react';

export const PANEL_STATE = {
  CLOSED: 'closed',
  OPEN: 'open',
  MINIMIZED: 'minimized',
};

const ChatWidgetContext = createContext(null);

export function ChatWidgetProvider({ children }) {
  const [panelState, setPanelState] = useState(PANEL_STATE.CLOSED);
  const [openSource, setOpenSource] = useState(null); // 'fab' | 'header' | 'inline' | 'nudge'

  const openPanel = useCallback((source = 'fab') => {
    setOpenSource(source);
    setPanelState(PANEL_STATE.OPEN);
  }, []);

  const closePanel = useCallback(() => {
    setPanelState(PANEL_STATE.CLOSED);
    setOpenSource(null);
  }, []);

  const minimizePanel = useCallback(() => {
    setPanelState(PANEL_STATE.MINIMIZED);
  }, []);

  const value = {
    panelState,
    openPanel,
    closePanel,
    minimizePanel,
    openSource,
  };

  return (
    <ChatWidgetContext.Provider value={value}>
      {children}
    </ChatWidgetContext.Provider>
  );
}

export function useChatWidget() {
  const ctx = useContext(ChatWidgetContext);
  if (!ctx) {
    throw new Error('useChatWidget must be used within ChatWidgetProvider');
  }
  return ctx;
}
